<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.5714 1.42847L1.42859 18.5713M1.42859 1.42847L18.5714 18.5713"
      stroke="#414B4C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconVectorDark',
};
</script>
